// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2nm_g","footer":"ModalError_footer__2ZBX6"};